/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Status_Awaiting_ProcessingInputs */

const en_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting Processing`)
};

const fr_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente de traitement`)
};

const de_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitung ausstehend`)
};

const it_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In attesa di elaborazione`)
};

const ru_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидается обработка`)
};

const es_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En espera de procesamiento`)
};

const zh_cn2_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待处理`)
};

const ja_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理待ち`)
};

const hi_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोसेसिंग का इंतजार है`)
};

const pt_pt2_embed_captions_status_awaiting_processing = /** @type {(inputs: Embed_Captions_Status_Awaiting_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardando processamento`)
};

/**
* | output |
* | --- |
* | "Awaiting Processing" |
*
* @param {Embed_Captions_Status_Awaiting_ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_status_awaiting_processing = /** @type {((inputs?: Embed_Captions_Status_Awaiting_ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Status_Awaiting_ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_status_awaiting_processing(inputs)
	if (locale === "de") return de_embed_captions_status_awaiting_processing(inputs)
	if (locale === "it") return it_embed_captions_status_awaiting_processing(inputs)
	if (locale === "ru") return ru_embed_captions_status_awaiting_processing(inputs)
	if (locale === "es") return es_embed_captions_status_awaiting_processing(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_status_awaiting_processing(inputs)
	if (locale === "ja") return ja_embed_captions_status_awaiting_processing(inputs)
	if (locale === "hi") return hi_embed_captions_status_awaiting_processing(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_status_awaiting_processing(inputs)
	return en_embed_captions_status_awaiting_processing(inputs)
});